import { servicosSaudeParametrosApi } from "@/api/ServicosSaudeParametrosApi";
import ParametrosModel from "@/models/cadastros/saude/ParametrosModel";

class ParametrizacaoService {
  obterParametros() {
    return servicosSaudeParametrosApi.obterParametros();
  }

  atualizar(parametros: ParametrosModel) {
    return servicosSaudeParametrosApi.atualizarParametros(parametros);
  }
}

export const parametrizacaoService = new ParametrizacaoService();
